import { useNavigate } from "react-router-dom";
import Button from "@/components/common/Button";
import WebIcon from "@/components/common/Web_Icons";
import PropTypes from "prop-types";

const EmptyState = ({ "data-testid": dataTestId }) => {
  const navigate = useNavigate();

  const handleSetupClick = () => {
    navigate("/dashboard/events/add");
  };

  return (
    <div
      data-testid={dataTestId || "empty-state"}
      className="flex flex-col items-center justify-center rounded-lg p-8 mt-6 max-w-[600px] mx-auto">
      <WebIcon
        icon="CampaignHover"
        size="large"
        className="mb-6 w-[100px] h-[100px]"
        data-testid="empty-state-icon"
      />
      <h2
        className="mb-4 heading-large whitespace-nowrap font-bold text-lighterGrey"
        data-testid="empty-state-title">
        Events Empty
      </h2>
      <p
        className="mb-8 font-normal text-bold-x text-lighterGrey"
        data-testid="empty-state-description">
        There&apos;s nothing to show here.
      </p>
      <Button
        text="CREATE NEW EVENT"
        color="primary"
        className="w-full px-6 py-3 font-medium text-white"
        customBgColor="primary"
        customTextColor="white"
        onClick={handleSetupClick}
        data-testid="create-event-button"
      />
    </div>
  );
};

EmptyState.propTypes = {
  "data-testid": PropTypes.string,
};

export default EmptyState;
